"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _useIsomorphicLayoutEffect = _interopRequireDefault(require("../../../../hooks/useIsomorphicLayoutEffect"));
var _useVideo = _interopRequireDefault(require("../../hooks/useVideo"));
var _provider = _interopRequireDefault(require("./provider"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = void 0 && (void 0).__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var YouTubeProvider = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var _a = (0, _useVideo.default)(),
    id = _a.id,
    src = _a.src,
    width = _a.width,
    height = _a.height,
    onReady = _a.onReady,
    onEvent = _a.onEvent;
  // eslint-disable-next-line no-undef
  var _b = (0, _react.useState)(null),
    player = _b[0],
    setPlayer = _b[1];
  var _c = (0, _react.useState)(null),
    iframeRef = _c[0],
    setIframeRef = _c[1];
  var _d = (0, _react.useState)(false),
    isReady = _d[0],
    setIsReady = _d[1];
  var _e = (0, _react.useState)(function () {
      return _provider.default.getVideoId(src);
    }),
    videoId = _e[0],
    setVideoId = _e[1];
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      player: player,
      _domRef: iframeRef
    };
  }, [player, iframeRef]);
  (0, _useIsomorphicLayoutEffect.default)(function () {
    // eslint-disable-next-line no-undef
    var _player = null;
    var createPlayer = function createPlayer() {
      return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              _provider.default.initiate();
              return [4 /*yield*/, _provider.default.onReady()];
            case 1:
              _a.sent();
              _player = new window.YT.Player("youtube-player-id__".concat(id), {
                events: {
                  onReady: function onReady() {
                    setIsReady(true);
                  },
                  onStateChange: function onStateChange(event) {
                    onEvent(event);
                  }
                }
              });
              setPlayer(_player);
              return [2 /*return*/];
          }
        });
      });
    };

    createPlayer();
    return function () {
      _player === null || _player === void 0 ? void 0 : _player.destroy();
    };
  }, [id, onEvent]);
  (0, _react.useEffect)(function () {
    if (isReady) {
      onReady();
    }
  }, [isReady, onReady]);
  (0, _react.useEffect)(function () {
    setVideoId(_provider.default.getVideoId(src));
  }, [src]);
  var videoSrc = _provider.default.getVideoSrc(videoId);
  return videoSrc ? (0, _jsxRuntime.jsx)("iframe", __assign({
    id: "fluffy-youtube-player-".concat(id),
    title: "YouTube video player",
    width: width,
    height: height,
    allowFullScreen: true,
    frameBorder: '0'
  }, props, {
    src: videoSrc,
    ref: setIframeRef
  })) : null;
});
var _default = YouTubeProvider;
exports.default = _default;